import '../upsert-collection-layer/upsert-collection-layer.js';
import '../wishlist-collection/wishlist-collection.js';
import {css, CSSResult, html, LitElement, unsafeCSS} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {SharedCollection} from '../../../@types/wishlist.js';
import {repeat} from 'lit/directives/repeat.js';
import typographyStyles from '../../../styles/responsive-nui-typography.scss';
import styles from './wishlist-curated-collections.scss';
import {consume} from '@lit/context';
import {curatedCollectionContext} from '../../../scripts/context/wishlistContext.js';
import {CuratedCollectionsState} from '../../../scripts/context/wishlist-state.js';
import {WishlistAppConfig, wishlistAppConfigContext} from '../../../scripts/context/appConfigContext.js';

@customElement('ents-wishlist-curated-collections')
export class WishlistCuratedCollections extends LitElement {
  @consume({context: wishlistAppConfigContext})
  private wishlistAppConfig!: WishlistAppConfig;

  @consume({context: curatedCollectionContext})
  private curatedCollectionsState!: CuratedCollectionsState;

  @state()
  private collections: SharedCollection[] = [];

  static get styles(): CSSResult[] {
    return [css`${unsafeCSS(styles)}`, css`${unsafeCSS(typographyStyles)}`];
  }

  async loadCollections() {
    this.collections = await this.curatedCollectionsState.getAll(this.wishlistAppConfig.curatedCollectionApiEndpoint);
  }

  connectedCallback(): void {
    super.connectedCallback();
    void this.loadCollections();
  }

  render() {
    return html`
      <div class="ents-wishlist-collection-container">
        <div class="ents-wishlist-collection-grid">
          ${repeat(this.collections, col => col.collection.id, col => html`
            <article>
              <ents-wishlist-collection
                .wishlistCollection="${col.collection}"
                .products="${col.products}"
                curated-collection/>
            </article>
          `)}
        </div>
      </div>
    `;
  }
}
